
    // this file was auto generated by python script
    import Volume from './Volume';
    export default Volume;
    